import { FC } from 'react';
import { useFavoriteToggleContext } from '#baseMenu/components';

const AdvertFavoriteBottomSheetHolder: FC = () => {
  const { AdvertFavoriteBottomSheet, isLoaded } = useFavoriteToggleContext();

  if (!isLoaded) {
    return null;
  }

  return <AdvertFavoriteBottomSheet />;
};

export { AdvertFavoriteBottomSheetHolder };
